<template>
  <div
    v-if="filter.visible"
    class="row"
  >
    <div class="col-xs-5">
      <label
        :for="filter.name"
        class="control-label"
      >{{ filter.label }}</label>
    </div>
    <div class="col-xs-7 validate-input">
      <template v-if="filter.type == 'checkbox'">
        <input
          :id="filter.name"
          v-model="filterValue"
          type="checkbox"
          :checked="checked"
          @change="updated"
        >
      </template>

      <template v-else-if="filter.type == 'dropdown'">
        <select
          v-model="filterValue"
          class="mdb-select md-form form-control"
          @change="updated"
        >
          <option
            v-for="option in filterOptions"
            :value="option.name"
          >
            {{ option.label }}
          </option>
        </select>
      </template>

      <template v-else-if="filter.type == 'date'">
        <el-date-picker
          v-model="filterValue"
          prefix-icon=""
          type="date"
          size="small"
          format="dd-MM-yyyy"
          value-format="yyyy-MM-dd"
          :picker-options="pickerOptions"
          @input="updated"
          @change="updated"
        />

        <!--<input :id="filter.name" type="text" @input="updated" @change="updated"-->
        <!--v-model="filterValue" class="form-control" style="margin-top: -8px"></input>-->
      </template>
    </div>
  </div>
</template>

<script>
import { DatePicker } from 'element-ui'
import locale from 'element-ui/lib/locale'

const lang = require(`element-ui/lib/locale/lang/${Lang.locale}`).default
locale.use(lang)

export default {
  name: 'FilterComponent',
  components: {
    DatePicker,
  },
  props: {
    filter: { required: true },

  },
  data () {
    return {
      filterValue: null,
      filterOptions: null,
      pickerOptions: {
        firstDayOfWeek: 1,
      },
    }
  },
  computed: {
    checked () {
      return this.filter.value !== 'undefined' && this.filter.value == 1
    },
  },
  mounted () {
    this.filterValue = this.filter.value
    this.filterOptions = this.filter.options
  },
  methods: {
    updated: function () {
      this.$emit('inputUpdated', { name: this.filter.name, value: this.filterValue })
    },
  },
}
</script>

<style scoped>

    .col-xs-5, .col-xs-7, .col-sm-5, .col-sm-7 {
        padding-left: 0;
    }

    .row {
        margin: 5px 0;
    }

    .el-date-editor.el-input, .el-date-editor.el-input__inner {
        max-width: 100%;
        margin-top: -5px; margin-bottom: 5px;
    }
</style>
